import { Container, Row } from "reactstrap";
import BasicTimeline from "./BasicTimeline";
import VariationTimeline from "./VariationTimeline";
import HorizontalTimeline from "./HorizontalTimeline";
import { BonusUi, TimelineTitle } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import HoverTimeline from "./hoverTimeline";
import TimelineMain from "./timelineMain";

const TimelineContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TimelineTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <BasicTimeline />
          <HoverTimeline />
          <VariationTimeline />
          <HorizontalTimeline />
          <TimelineMain />
        </Row>
      </Container>
    </>
  );
};
export default TimelineContainer;
